<div class="form-page-pager flex flex-wrap items-center justify-end gap-2">
  <div class="form-page-pager__control inline-flex items-stretch overflow-hidden rounded-xl border border-slate-200 bg-white">
    <button
      type="button"
      class="form-page-pager__nav"
      [disabled]="!canGoPrev()"
      aria-label="Previous page"
      (click)="goPrev($event)">
      <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M15 6l-6 6 6 6"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </button>

    <div class="min-w-[9.5rem] border-x border-slate-200">
      <button
        type="button"
        class="form-page-pager__label"
        aria-haspopup="dialog"
        aria-label="Manage pages"
        (click)="onOpenPagesManager($event)">
        <span>{{ label() }}</span>
        <svg class="h-3.5 w-3.5 shrink-0 text-slate-400" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M6 9l6 6 6-6"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>
    </div>

    <button
      type="button"
      class="form-page-pager__nav"
      [disabled]="!canGoNext()"
      aria-label="Next page"
      (click)="goNext($event)">
      <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M9 6l6 6-6 6"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </button>
  </div>

  <button
    type="button"
    class="inline-flex h-9 cursor-pointer items-center gap-1.5 rounded-lg border border-slate-900 bg-slate-900 px-3 text-xs font-medium text-white transition hover:border-slate-800 hover:bg-slate-800"
    (click)="onAddPage($event)">
    <svg class="h-3.5 w-3.5 shrink-0" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M12 5v14M5 12h14"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round" />
    </svg>
    Add page
  </button>
</div>
